import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Landingpage.css";

const TILES = [
    { key: "kpi", label: "KPI", path: "/kpidetails", desc: "Usage and performance metrics across countries." },
    { key: "broadcast", label: "Broadcast", path: "/broadcastmessage", desc: "Compose and send messages to users." },
    { key: "broadcastreport", label: "Broadcast Report", path: "/BroadcastReport", desc: "Delivery and engagement reports." },
    { key: "feedback", label: "Feedback", path: "/feedback", desc: "Review user feedback on bot responses." },
    { key: "kmanalysis", label: "KM Analysis", path: "/kmanalysis", desc: "Knowledge-management gaps and analysis." },
    { key: "transcript", label: "Transcript", path: "/transcript", desc: "Browse conversation transcripts." },
    { key: "outage", label: "Outage messages", path: "/outage-info", desc: "Manage outage notices shown to users." },
    { key: "access-management", label: "Access management", path: "/accessmanagement", desc: "Grant or revoke feature access." },
];

const Landingpage = () => {
    const navigate = useNavigate();
    const [features, setFeatures] = useState(null);
    const [username, setUsername] = useState("");

    useEffect(() => {
        const load = async () => {
            try {
                const res = await fetch("/api/access/mine");
                const data = await res.json();
                setFeatures(res.ok ? data.features || [] : []);
            } catch (err) {
                console.log(err);
                setFeatures([]);
            }
            try {
                const res = await fetch("/api/user/info");
                if (res.ok) {
                    const data = await res.json();
                    setUsername(data.username || "");
                }
            } catch (err) {
                console.log(err);
            }
        };
        load();
    }, []);

    if (features === null) {
        return (
            <div className="lp-root">
                <div className="lp-loading">
                    <span className="lp-loading-dot" />
                    Loading your workspace…
                </div>
            </div>
        );
    }

    const tiles = TILES.filter((t) => features.includes(t.key));

    return (
        <div className="lp-root">
            <header className="lp-hero">
                <div>
                    <p className="lp-eyebrow">AskIT Admin portal</p>
                    <h1 className="lp-title">Welcome{username ? `, ${username.split("@")[0]}` : ""}</h1>
                </div>

                <div className="lp-scanline" />
            </header>

            {tiles.length ? (
                <div className="lp-grid">
                    {tiles.map((t, i) => (
                        <button key={t.key} type="button" className="lp-card" onClick={() => navigate(t.path)}>
                            <span className="lp-card-top">
                                <span className="lp-card-index">{String(i + 1).padStart(2, "0")}</span>
                                <span className="lp-card-arrow" aria-hidden="true">→</span>
                            </span>
                            <span className="lp-card-title">{t.label}</span>
                            <span className="lp-card-desc">{t.desc}</span>
                        </button>
                    ))}
                </div>
            ) : (
                <div className="lp-empty">
                    <p className="lp-empty-title">No modules assigned</p>
                    <p>You don't have access to any features yet. Please contact an administrator.</p>
                </div>
            )}
            <div style={{ height: "150px" }}></div>
        </div>
    );
};

export default Landingpage;